module.exports = __webpack_public_path__ + "static/media/qempo-computer.425c731f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/qempo-computer.png
// module id = 1240
// module chunks = 0